import { css } from "@emotion/css";
import React from "react";

import { Divider } from "../../components/divider/Divider";
import { Text } from "../../foundations/typography/Text";

interface LegacyMenuSectionProps {
  children: React.ReactElement[] | React.ReactElement;
  title?: string;
  testID?: string;
}

/**
 * @deprecated see DropdownMenu
 */
export function LegacyMenuSection({
  children,
  title,
  testID = "menu-section",
}: LegacyMenuSectionProps) {
  return (
    <>
      {title && (
        <Divider
          marginVertical="space-1"
          className={styles.menuSectionDivider}
        />
      )}
      <div className={styles.actionArea} data-testid={testID}>
        {title && (
          <Text style="input/label" className={styles.sectionHeader}>
            {title}
          </Text>
        )}
        {children}
      </div>
    </>
  );
}

const styles = {
  menuSectionDivider: css({
    "&:first-child": css({
      display: "none",
    }),
  }),
  sectionHeader: css({
    padding: `${"var(--space-05)"} ${"var(--space-4)"}`,
    marginBottom: "var(--space-1)",
    display: "inline-block",
  }),

  actionArea: css({
    paddingTop: "var(--space-1)",
    paddingBottom: "var(--space-1)",
  }),
};
